import { serverNow } from '@/libs/serverTime'

export default {
  data() {
    return {
      elapsedNow: serverNow(),
      elapsedTimer: null,
    };
  },

  mounted() {
    this.elapsedTimer = setInterval(() => {
      this.elapsedNow = serverNow();
    }, 1000);
  },

  beforeDestroy() {
    if (this.elapsedTimer) {
      clearInterval(this.elapsedTimer);
    }
  },

  methods: {
    elapsedHHMMSS(dateStr) {
      if (!dateStr) return '--:--:--';
      const now = this.elapsedNow;
      const diff = Math.max(0, Math.floor((now - new Date(dateStr).getTime()) / 1000));
      const h = Math.floor(diff / 3600);
      const m = Math.floor((diff % 3600) / 60);
      const s = diff % 60;
      return [h, m, s].map((v) => String(v).padStart(2, '0')).join(':');
    },

    elapsedBadgeClass(dateStr) {
      if (!dateStr) return 'badge elapsed-badge elapsed-badge--ok';
      const now = this.elapsedNow;
      const seconds = Math.floor((now - new Date(dateStr).getTime()) / 1000);
      if (seconds < 90) return 'badge elapsed-badge elapsed-badge--ok';
      if (seconds < 180) return 'badge elapsed-badge elapsed-badge--warning';
      return 'badge elapsed-badge elapsed-badge--danger';
    },
  },
};
